import React, { useEffect, useState } from "react";
import axios from "axios";
import DigitalAssetsChart from "../utils/DigitalAssetsChart";
import ImageLoading from "../../../components/ImageLoading";

const DigitalAssets = ({ tab }) => {
  const [graph, setGraph] = useState({});
  const [activeDuration, setActiveDuration] = useState("weekly");

  const dates = [];
  const mutualFunds = [];
  const stocks = [];
  const bankStatements = [];
  const nps = [];
  const [loading, setLoading] = useState(false);

  const getDashboardUserDetails = async () => {
    setLoading(true);

    const token = localStorage.getItem("token");

    const url = `${process.env.REACT_APP_URL}/lender/v1/dashboards/digital_assets_graph`;
    const options = {
      url: url,
      method: "GET",
      headers: { Authorization: token },
    };
    const res = await axios(options);
    setGraph(res.data.data);
    setLoading(false);
  };

  for (const key in graph) {
    dates.push(key);
    mutualFunds.push(graph[key].mutual_fund);
    stocks.push(graph[key].stocks);
    bankStatements.push(graph[key].banks);
    nps.push(graph[key].nps);
  }

  useEffect(() => {
    getDashboardUserDetails();
    // setGraph(data);
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex w-full h-full justify-center items-center">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div className=" pt-4 h-full  ">
            <div className="flex justify-between items-center mb-[22px] ml-4">
              <p className="text-[16px] font-semibold">Digital Assets</p>
            </div>
            <div className="  pl-[27.5px] pr-[12px]">
              <DigitalAssetsChart
                dates={dates}
                mutualFunds={mutualFunds}
                stocks={stocks}
                bankStatements={bankStatements}
                nps={nps}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DigitalAssets;
